

import React, { memo, useCallback, useState } from 'react';
import { MenuButton } from '../../../../../ui-kit';
import CreditMenu from './CreditMenu';
import hasTeamsCredits from '../utils/hasTeamCredits';
import LiveChatModal from './CreditMenuSubscription/components/LiveChatModal';

import '../styles/_credits-info.scss';














function getCreditsTotal({ teams, creditBalance, creditType }) {
  if (!creditType) {
    return {
      balance: 0,
      rolloverBalance: 0
    };
  }

  if (hasTeamsCredits({ creditType, teams })) {
    return teams.reduce((total, team) => {
      const { creditBalance: teamCreditBalance } = team;

      if (!teamCreditBalance) {return total;}

      return {
        balance: teamCreditBalance.balance + total.balance,
        rolloverBalance: teamCreditBalance.rolloverBalance + total.rolloverBalance
      };
    }, { balance: 0, rolloverBalance: 0 });
  }

  return creditBalance;
}

function CreditsInfo({
  isUnlimited,
  creditBalance,
  creditType,
  teams = [],
  onClickTopUpNow
}) {
  const [showLiveChatModal, setShowLiveChatModal] = useState(false);

  const creditsTotalCallback = useCallback(
    () => getCreditsTotal({ teams, creditBalance, creditType }), [teams, creditBalance, creditType]
  );

  const onLiveChatModalOpen = () => {
    if (onClickTopUpNow) {
      onClickTopUpNow();
      return;
    }
    setShowLiveChatModal(true);
  };
  const onLiveChatModalClose = () => setShowLiveChatModal(false);

  const totalCreditsBalance = creditsTotalCallback();
  const balanceToDisplay = totalCreditsBalance.balance + totalCreditsBalance.rolloverBalance;

  const checkHasTeamsCredits = hasTeamsCredits({ creditType, teams });
  const creditsText = balanceToDisplay === 1 ? 'credit' : 'credits';

  if (!creditType) {return null;}

  return (
    <>
      <MenuButton
        id="credits-info"
        buttonProps={{
          prefix: !checkHasTeamsCredits && isUnlimited ? 'unlimited' : void 0,
          children: `${!checkHasTeamsCredits && isUnlimited ? '' : balanceToDisplay} ${creditsText} remaining`
        }}>

        <CreditMenu
          creditBalance={creditBalance}
          isUnlimited={isUnlimited}
          creditType={creditType}
          teams={teams}
          hasTeamsCredits={Boolean(checkHasTeamsCredits)}
          onLiveChatModalOpen={onLiveChatModalOpen} />

      </MenuButton>
      {showLiveChatModal &&
      <LiveChatModal
        saveButtonId="topup-credits-v1"
        visible={showLiveChatModal}
        closeModal={onLiveChatModalClose}
        saveText="Live Chat Now"
        title="Run out of credits?"
        contentHeading="We can top up your workspace or team credits instantly!"
        content={
        <>
            <p>
              Simply reach out to us on Live Chat, answer a few questions
              & we can get this rolling straight away.
            </p>
            <p>Credits will be applied instantly & invoiced later</p>
          </>} />}



    </>);

}

export default memo(CreditsInfo);